import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "single-sign-on",
  courseId: "for-agency-admins",
  order: 5,
  title: "Single sign-on",
  summary:
    "Connect Entra ID, Okta, Google Workspace, or any SAML provider so officers sign in with their city credentials and accounts are created automatically.",
  learn: [
    "Configure a SAML or OIDC provider",
    "Understand auto-provisioning and invites under SSO",
    "Turn SSO off without stranding officers",
  ],
  minutes: 4,
  releasedAt: "2026-10-14T00:00:00.000Z",
  gate: "admin",
  body: [
    {
      type: "steps",
      items: [
        "Open the **Single Sign-On** tab and pick your provider: Microsoft Azure AD / Entra ID, Okta, Google Workspace, or Custom SAML Provider.",
        "Enter the on-screen values (entity ID, ACS or redirect URL) in your identity provider.",
        "Paste back the metadata or client details it gives you.",
        "Set the email domain SSO covers.",
        "Enable it and save.",
        "Test with your own officer account before announcing.",
        "Invite officers as usual.",
      ],
    },
    {
      type: "paragraph",
      text: "An officer's invite link goes to the login page and on to your provider. The account is created on first sign-in and matched to the invite by email.",
    },
    {
      type: "callout",
      tone: "note",
      title: "No passwords",
      text: "SSO-provisioned officers have no password. If one tries the password form, the app tells them to use single sign-on instead of issuing a password, because a password would bypass your provider.",
    },
    {
      type: "callout",
      tone: "warning",
      title: "Turning SSO off",
      text: "Saving the configuration with SSO disabled, or changing the domain, emails every password-less officer a link to set a password. Do it during business hours so people can act on the email.",
    },
    {
      type: "paragraph",
      text: "SSO handles identity. The MFA tab still decides whether a second factor is required inside the app. Many departments rely on the provider's MFA and leave in-app enforcement off. Check your CJIS auditor's expectations.",
    },
    {
      type: "paragraph",
      text: "The MFA policy lesson covers the in-app settings.",
    },
  ],
  related: ["invite-officers-and-roles", "mfa-policy"],
};

export default lesson;
